<template>
  <div class="content my-0 py-1">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 mt-2 py-0 d-flex justify-content-between align-items-center flex-wrap">
          <h4 class="m-0 p-0 text-secondary font-weight-bold">
            {{ dicts.label_head_troubleshoot[dicts.lang] }}
          </h4>
          <button 
            class="btn btn-primary shadow-sm mt-2 mt-md-0 px-4" 
            @click="formTroubleshootActive = !formTroubleshootActive"
          >
            <b-icon :icon="formTroubleshootActive ? 'dash-circle' : 'plus-circle'" class="mr-1"></b-icon>
            {{ dicts.label_add_troubleshoot[dicts.lang] }}
          </button>
        </div>

        <transition name="fade">
          <div class="col-12 my-3 py-0" v-if="formTroubleshootActive">
            <div class="card border-0 shadow-sm rounded-lg">
              <div class="card-body p-4">
                <h5 class="card-title mb-4 text-primary">{{ dicts.label_form_troubleshoot_baru[dicts.lang] }}</h5>
                <hr>
                <div class="row">
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">SPKP ID <span class="text-danger">*</span></label>
                    <smart-search init url="/api/seeker/sold-hardware-setup" 
                      :label-tag="['id_transmitter']" key-tag="id_transmitter" 
                      @update="smartSearchAddIdTransmitter" 
                      :search-value="newhardwareidlabel" 
                      @update-direct="(label)=>newhardwareidlabel=label">
                    </smart-search>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">SERIAL NUMBER</label>
                    <div class="form-control bg-light border-0 rounded text-muted">{{ (selectedHardwareSetup.serial_number && selectedHardwareSetup.serial_number.serial_number) || '-' }}</div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">VASSEL NAME</label>
                    <div class="form-control bg-light border-0 rounded text-muted">{{ (selectedHardwareSetup.vessel && selectedHardwareSetup.vessel.name) || '-' }}</div>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">TYPE DEVICE<span class="text-danger">*</span></label>
                    <input 
                      type="text" 
                      class="form-control rounded" 
                      placeholder="Nama Perangkat"
                      v-model="newTroubleshoot.typeDevice"
                    />
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">PERSON RESPONSIBLE<span class="text-danger">*</span></label>
                    <input 
                      type="text" 
                      class="form-control rounded" 
                      placeholder="Penanggung Jawab"
                      v-model="newTroubleshoot.responsiblePerson"
                    />
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">NO. HP<span class="text-danger">*</span></label>
                    <input 
                      type="text" 
                      class="form-control rounded" 
                      placeholder="Contoh: 08123456789"
                      v-model="newTroubleshoot.noHp"
                    />
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">COMPLAINT<span class="text-danger">*</span></label>
                    <smart-search init url="/api/master/seeker/troubleshoot-complaint" :label-tag="['complaint_name']" key-tag="complaint_name" @update="smartSearchAddComplaint" :search-value="newcomplaintlabel" @update-direct="(label)=>newcomplaintlabel=label"></smart-search>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">STATUS</label>
                    <smart-select :options="statusTroubleshoot" @update="updateStatus"></smart-select>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">START DATE <span class="text-danger">*</span></label>
                    <b-form-datepicker locale="id" v-model="newTroubleshoot.startDate" class="rounded"></b-form-datepicker>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                    <label class="font-weight-bold small">LOCATION</label>
                    <smart-search init url="/api/master/seeker/troubleshoot-location" :label-tag="['location_name']" key-tag="location_name" @update="smartSearchAddLocation" :search-value="newlocationlabel" @update-direct="(label)=>newlocationlabel=label"></smart-search>
                  </div>
                  <div class="col-12 col-md-6 col-lg-4 mb-3">
                  <label class="font-weight-bold small">UPLOAD IMAGE TO SYNOLOGY</label>
                  <div class="custom-file">
                    <input type="file" class="custom-file-input" id="imageTroubleshoot" accept="image/*" @change="handleFileChange">
                    <label class="custom-file-label text-muted small text-truncate" for="imageTroubleshoot">
                      {{ selectedFileName || 'Pilih gambar bukti...' }}
                    </label>
                  </div>
                  <div v-if="imagePreview" class="mt-2 d-flex align-items-center">
                    <img :src="imagePreview" class="img-thumbnail" style="max-height: 60px;" alt="Preview">
                    <button type="button" class="btn btn-sm btn-link text-danger ml-2" @click="removeImage">Hapus</button>
                  </div>
                </div>
                  <div class="col-12 col-lg-8 mb-3">
                    <label class="font-weight-bold small">INFORMATION</label>
                    <textarea class="form-control rounded" v-model="newTroubleshoot.notes" rows="2"></textarea>
                  </div>
                </div>

                <div class="mt-2" v-if="newSaved || errorNew">
                  <div :class="newSaved ? 'alert alert-success' : 'alert alert-danger'" role="alert">
                    {{ newSaved ? 'Berhasil menyimpan data.' : createErrorMessage }}
                  </div>
                </div>

                <div class="text-right mt-3">
                  <button class="btn btn-primary px-5 shadow-sm" :disabled="savingNew" @click="saveNewTroubleshoot">
                    <span v-if="savingNew" class="spinner-border spinner-border-sm mr-2"></span>Simpan Data
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <div class="col-12 my-2 py-0">
          <div class="card shadow-sm border-0 rounded-lg overflow-hidden">
            <div class="card-body p-0">
              <datatable noborder 
                :lang="dicts.lang" :datas="troubleshoots" :structure="TableStructure" :init="loadData" :hide-pagination="true"
                @refetch="(row)=>{rowLimit=row;getTroubleshoots()}" 
                @searching="(val)=>!val.status?getTroubleshoots():troubleshoots=val.data.data">
                
                <template #customcell="{obj, index}">
                  <td v-if="isMobile" class="p-3 border-0">
                    <div class="mobile-card rounded border p-3 shadow-sm mb-2 bg-white" :class="statusClass(obj.status)">
                      <div class="d-flex justify-content-between align-items-start border-bottom pb-2 mb-2">
                        <div>
                          <small class="text-muted d-block">Serial Number</small>
                          <strong class="text-primary">{{ (obj.hardware_setup && obj.hardware_setup.serial_number && obj.hardware_setup.serial_number.serial_number) || '-' }}</strong>
                        </div>
                        <span :class="statusBadge(obj.status)">{{ obj.status }}</span>
                      </div>
                      
                      <div class="row small mb-2">
                        <div class="col-6"><strong>ID:</strong> {{ (obj.hardware_setup && obj.hardware_setup.id_transmitter) || '-' }}</div>
                        <div class="col-6 text-right"><strong>JB:</strong> {{ (obj.hardware_setup && obj.hardware_setup.jb) ? obj.hardware_setup.jb.serial_number : '-' }}</div>
                        <div class="col-12 mt-1"><strong>Type Device:</strong> {{ obj.typeDevice || '-' }}</div>
                        <div class="col-12 mt-1"><strong>Kapal:</strong> {{ (obj.hardware_setup && obj.hardware_setup.vessel) ? obj.hardware_setup.vessel.name : '-' }}</div>
                        <div class="col-12 mt-1"><strong>Keluhan:</strong> {{ obj.responsiblePerson || '-' }}</div>
                        <div class="col-12 mt-1"><strong>Keluhan:</strong> {{ obj.noHp || '-' }}</div>
                        <div class="col-12 mt-1"><strong>Keluhan:</strong> {{ obj.complaint || '-' }}</div>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                        <small class="text-muted">{{ obj.start_date | timeformat }}</small>
                        <div class="btn-group">
                          <b-button size="sm" variant="outline-info" @click="selectedDetail=index" v-b-modal.modal-detail-pengguna>
                            <b-icon icon="eye"></b-icon>
                          </b-button>
                          <b-button size="sm" variant="outline-primary" v-if="checkRoleUpdate(obj)" @click="openEdit(obj, index)">
                            <b-icon icon="pencil"></b-icon>
                          </b-button>
                          <b-button size="sm" variant="outline-primary" v-if="checkRoleUpdate(obj)" @click="openEdit(obj, index)">
                            <b-icon icon="pencil"></b-icon>
                          </b-button>
                          <b-button size="sm" variant="outline-primary" v-if="checkRoleUpdate(obj)" @click="openEdit(obj, index)">
                            <b-icon icon="pencil"></b-icon>
                          </b-button>
                          <b-button size="sm" variant="outline-danger" v-if="checkRoleDelete(obj)" @click="deleteId=obj.id; itemToDelete=obj" v-b-modal.modal-delete>
                            <b-icon icon="trash"></b-icon>
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </td>

                  <template v-else>
                    <td class="text-center align-middle">{{ ((currentPage - 1) * rowLimit) + (index + 1) }}</td>
                    <td class="align-middle font-weight-bold text-primary text-nowrap">
                      {{ (obj.hardware_setup && obj.hardware_setup.serial_number && obj.hardware_setup.serial_number.serial_number) || '-' }}
                    </td>
                    <td class="align-middle text-nowrap">{{ (obj.hardware_setup && obj.hardware_setup.id_transmitter) || '-' }}</td>
                    <td class="align-middle text-center">{{ (obj.hardware_setup && obj.hardware_setup.jb) ? obj.hardware_setup.jb.serial_number : '-' }}</td>
                    <td class="align-middle small">{{ obj.type_device || '-' }}</td>
                    <td class="align-middle">{{ (obj.hardware_setup && obj.hardware_setup.vessel) ? obj.hardware_setup.vessel.name : '-' }}</td>
                     <td class="align-middle small">{{ obj.responsible_person || '-' }}</td>
                    <td class="align-middle small">{{ obj.no_hp || '-' }}</td>
                    <td class="align-middle text-nowrap small">{{ obj.start_date | timeformat }}</td>
                    <td class="align-middle small">{{ obj.complaint || '-' }}</td>
                    <td class="align-middle text-nowrap small">{{ obj.end_date | timeformat}}</td> 
                    <td class="align-middle small">{{ obj.solution || '-' }}</td> 
                    <td class="align-middle text-center"><span :class="statusBadge(obj.status)">{{ obj.status }}</span></td>
                    <td class="align-middle text-center">
                      <b-dropdown variant="link" no-caret size="sm" >
                        <template #button-content><b-icon icon="three-dots-vertical" variant="dark"></b-icon></template>
                        <b-dropdown-item @click="selectedDetail=index" v-b-modal.modal-detail-pengguna><b-icon icon="eye" class="mr-2"></b-icon> Detail</b-dropdown-item>
                        <b-dropdown-item v-if="checkRoleUpdate(obj)" @click="openEdit(obj, index)"><b-icon icon="pencil" class="mr-2"></b-icon> Edit</b-dropdown-item>
                        <!-- <b-dropdown-item><b-icon icon="wrench" class="mr-2"></b-icon> Repair Order</b-dropdown-item> -->
                        <b-dropdown-divider></b-dropdown-divider>
                        <b-dropdown-item v-if="checkRoleDelete(obj)" variant="danger" @click="deleteId=obj.id; itemToDelete=obj" v-b-modal.modal-delete><b-icon icon="trash" class="mr-2"></b-icon> Deleted</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </template>
                </template>
              </datatable>

              <div class="d-flex flex-column flex-md-row justify-content-between align-items-center p-3 border-top bg-light">
                <div class="text-secondary small mb-3 mb-md-0">
                  Showing <b>{{ troubleshoots.length }}</b> of <b>{{ totalEntries }}</b> entries
                </div>
                <div class="btn-group shadow-sm bg-white rounded overflow-hidden">
                  <button class="btn btn-outline-light text-primary btn-sm px-4 border-right" :disabled="!prevUrl" @click="getTroubleshoots(prevUrl)">Previous</button>
                  <button class="btn btn-outline-light text-primary btn-sm px-4" :disabled="!nextUrl" @click="getTroubleshoots(nextUrl)">Next</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-edit-troubleshoot" title="EDIT TROUBLESHOOT" size="lg" centered @ok="updateTroubleshootData">
      <div v-if="dataEdit" class="row">
        <div class="col-md-6 mb-3">
          <label class="font-weight-bold small">STATUS</label>
          <smart-select 
            :key="dataEdit.id"
            :options="statusTroubleshoot" 
            usedefault
            :default-value="dataEdit.status" 
            @update="(v) => dataEdit.status = v">
          </smart-select>
        </div>
        <div class="col-md-6 mb-3">
          <label class="font-weight-bold small">END DATE</label>
          <b-form-datepicker v-model="dataEdit.end_date" locale="id"></b-form-datepicker>
        </div>
        <div class="col-md-6 mb-3">
          <label class="font-weight-bold small">TYPE DEVICE<span class="text-danger">*</span></label>
          <input 
            type="text" 
            class="form-control" 
            placeholder="Nama Perangkat"
            v-model="dataEdit.type_device"
          />
        </div>
        <div class="col-md-6 mb-3">
          <label class="font-weight-bold small">PERSON RESPONSIBLE<span class="text-danger">*</span></label>
          <input 
            type="text" 
            class="form-control" 
            placeholder="Penanggung Jawab"
            v-model="dataEdit.responsible_person"
          />
        </div>
        <div class="col-12 mb-3">
          <label class="font-weight-bold small">NO. HP<span class="text-danger">*</span></label>
          <input 
            type="tel" 
            class="form-control" 
            placeholder="Contoh: 08123456789"
            v-model="dataEdit.no_hp"
          />
        </div>
        <div class="col-12 mb-3">
          <label class="font-weight-bold small">SOLUTION/ACTIONS</label>
          <textarea class="form-control" v-model="dataEdit.solution" rows="3"></textarea>
        </div>
        <div class="col-12 mb-3">
          <label class="font-weight-bold small">INFORMATION</label>
          <textarea class="form-control" v-model="dataEdit.notes" rows="2"></textarea>
        </div>
        <div class="col-12 mb-3">
            <label class="font-weight-bold small">UPLOAD IMAGE TO SYNOLOGY</label>
              <div class="custom-file">
                <input type="file" class="custom-file-input" id="imageTroubleshoot" accept="image/*" @change="handleFileChange">
                <label class="custom-file-label text-muted small text-truncate" for="imageTroubleshoot">
                  {{ selectedFileName || 'Pilih gambar bukti...' }}
                </label>
              </div>
              <div v-if="imagePreview" class="mt-2 d-flex align-items-center">
                <img :src="imagePreview" class="img-thumbnail" style="max-height: 60px;" alt="Preview">
                <button type="button" class="btn btn-sm btn-link text-danger ml-2" @click="removeImage">Hapus</button>
              </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="modal-detail-pengguna" title="DETAIL" scrollable centered header-bg-variant="primary" header-text-variant="white">
      <div v-if="troubleshoots[selectedDetail]">
         <table class="table table-sm table-borderless m-0">
           <tbody>
             <tr><th width="40%">SPKP</th><td>: {{ troubleshoots[selectedDetail].hardware_setup.id_transmitter }}</td></tr>
             <tr><th>VASSEL NAME</th><td>: {{ troubleshoots[selectedDetail].hardware_setup.vessel.name }}</td></tr>
             <tr><th>SERIAL NUMBER</th><td>: {{ troubleshoots[selectedDetail].hardware_setup.serial_number.serial_number }}</td></tr>
             <tr><th>LOCATION</th><td>: {{ troubleshoots[selectedDetail].location.location_name }}</td></tr>
             <tr><th>COMPLAINT</th><td>: {{ troubleshoots[selectedDetail].complaint }}</td></tr>
             <tr><th>STATUS</th><td>: {{ troubleshoots[selectedDetail].status }}</td></tr>
             <tr><th>SOLUTIONS</th><td>: {{ troubleshoots[selectedDetail].solution || '-' }}</td></tr>
             <!-- <tr><th>PHOTO</th><td>: {{ troubleshoots[selectedDetail].photo || '-' }}</td></tr> -->
            <tr>
              <th>PHOTO URL</th>
              <td>{{ troubleshoots[selectedDetail].photo ? troubleshoots[selectedDetail].photo.photo_url : '-' }}</td>
            </tr>
            <tr>
              <th>PHOTO</th>
              <td>
                <div style="width: 200px; height: 200px; overflow: hidden; position: relative; border-radius: 8px;">
                  <iframe 
                    v-if="troubleshoots[selectedDetail] && troubleshoots[selectedDetail].photo && troubleshoots[selectedDetail].photo.photo_url" 
                    :src="troubleshoots[selectedDetail].photo.photo_url.replace('http://', 'http://habib:MSPCLOUDdev2026@')" 
                    width="1000" 
                    height="1000" 
                    style="border: none; 
                          position: absolute; 
                          top: 0; 
                          left: 0; 
                          transform: scale(0.2); 
                          transform-origin: 0 0;"
                  ></iframe>
                  <span v-else>-</span>
                </div>
              </td>
            </tr>
            
           </tbody>
         </table>
      </div>
    </b-modal>

    <modal-delete url="/api/troubleshoot/" :targetid="deleteId" @result="deleteResult">
      Yakin ingin menghapus data troubleshoot ini?
    </modal-delete>
  </div>
</template>

<script>
import axios from 'axios';
import Datatable from '../components/Datatable.vue';
import SmartSelect from '../components/SmartSelect.vue';
import SmartSearch from '../components/SmartSearch.vue';
import ModalDelete from '../components/ModalDelete.vue';

export default {
  components: { 
    'datatable': Datatable, 
    'smart-select': SmartSelect, 
    'smart-search': SmartSearch, 
    'modal-delete': ModalDelete 
  },
  data() {
    return {
      rowLimit: 10,
      totalEntries: 0,
      currentPage: 1,
      nextUrl: null,
      prevUrl: null,
      isMobile: false,
      loadData: true,
      savingNew: false,
      newSaved: false,
      errorNew: false,
      formTroubleshootActive: false,
      troubleshoots: [],
      dataEdit: null,
      selectedDetail: 0,
      deleteId: 0,
      itemToDelete: {},
      newhardwareidlabel: '',
      newcomplaintlabel: '',
      newlocationlabel: '',
      selectedHardwareSetup: {},
      createErrorMessage: 'Gagal menyimpan data.',
      newTroubleshoot: { 
        hardwareId: '', 
        technicianName: '', 
        typeDevice: '',
        responsiblePerson: '',
        noHp: '',
        startDate: new Date().toISOString().substr(0, 10), 
        status: 'Open', 
        notes: '', 
        complaint: '', 
        locationId: '' 
      },
        // New State Added Image Properties
        selectedFile: null,
        selectedFileName: '',
        imagePreview: null,
      TableStructure: [
        { label: 'NO', key: null }, 
        { label: 'SERIAL NUMBER', key: null }, 
        { label: 'SPKP ID', key: null }, 
        { label: 'NO JB', key: null },
        { label: 'TYPE DEVICE', key: null },
        { label: 'VESSEL NAME', key: null }, 
        { label: 'PIC', key: null }, 
        { label: 'NO HP', key: null }, 
        { label: 'START DATE', key: null }, 
        { label: 'COMPLAINT', key: null },
        { label: 'END DATE', key: null },
        { label: 'SOLUTIONS', key: null },
        { label: 'STATUS', key: null }, 
        { label: 'AKSI', key: null }
      ],
      dicts: { 
        lang: 'id', 
        label_head_troubleshoot: { id: 'TROUBLESHOOT', en: 'Troubleshoot List' }, 
        label_add_troubleshoot: { id: 'ADD NEW', en: 'ADD' }, 
        label_form_troubleshoot_baru: { id: 'New Form', en: 'New Form' },
        label_keluhan: { id: 'Keluhan', en: 'Complaint' },
        label_start_date: { id: 'Tgl Mulai', en: 'Start Date' },
        label_simpan: { id: 'Simpan', en: 'Save' } 
      },
      statusTroubleshoot: [
        { label: 'Open', value: 'Open' }, 
        { label: 'Pending', value: 'Pending' }, 
        { label: 'Close', value: 'Close' }
      ]
    }
  },
  created() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
    this.getTroubleshoots();
  },
  methods: {
    checkMobile() { 
      this.isMobile = window.innerWidth < 768; 
    },
    statusBadge(s) { 
      return s === 'Open' ? 'badge badge-success px-2' : s === 'Pending' ? 'badge badge-warning px-2' : 'badge badge-secondary px-2'; 
    },
    statusClass(s) {
      if (s === 'Open') return 'border-left-success';
      if (s === 'Pending') return 'border-left-warning';
      return 'border-left-secondary';
    },
    
    getTroubleshoots(url = null) {
      this.loadData = true;
      let targetUrl = url || (this.$baseUrl + '/api/troubleshoot?limit=' + this.rowLimit);
  
      if (targetUrl && window.location.protocol === 'https:' && targetUrl.startsWith('http://')) {
        targetUrl = targetUrl.replace('http://', 'https://');
      }

      axios.get(targetUrl, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') }})
      .then((res) => {
        this.troubleshoots = res.data.data;
        this.totalEntries = res.data.total;
        this.currentPage = res.data.current_page;
        this.nextUrl = res.data.next_page_url;
        this.prevUrl = res.data.prev_page_url;
        this.loadData = false;
      }).catch(() => { this.loadData = false; });
      
    },
    
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        if (file.size > 2048 * 1024) { 
          alert("Ukuran file terlalu besar! Maksimal 2MB.");
          this.removeImage();
          return;
        }
        this.selectedFile = file;
        this.selectedFileName = file.name;
        this.imagePreview = URL.createObjectURL(file);
      }
    },

    // 2. Fungsi Reset Gambar Terpilih
    removeImage() {
      this.selectedFile = null;
      this.selectedFileName = '';
      this.imagePreview = null;
      const input = document.getElementById('imageTroubleshoot');
      if (input) input.value = '';
    },
    
    saveNewTroubleshoot() {
      if (!this.newTroubleshoot.hardwareId) return alert("Pilih SPKP ID terlebih dahulu");
      this.savingNew = true;
      this.errorNew = false;
      this.newSaved = false;

      
      if (this.selectedFile) {
        const photoData = new FormData();
        photoData.append('image', this.selectedFile);

        axios.post(this.$baseUrl + '/api/v1/photos/upload', photoData, {
          headers: { 
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
          }
        })
        .then((res) => {
          if (res.data.success) {
            
            const photoId = res.data.data.id;
            
            this.submitMainTroubleshoot(photoId);
          } else {
            this.savingNew = false;
            alert("Failed to upload photos to Synology. Process aborted.");
          }
        })
        .catch((err) => {
          this.savingNew = false;
          this.errorNew = true;
          this.createErrorMessage = "Synology connection failed.";
        });

      } else {
        this.submitMainTroubleshoot(null);
      }
    },

    submitMainTroubleshoot(photoId) {
      axios.post(this.$baseUrl + '/api/troubleshoot', {
        hardware_setup_id: this.newTroubleshoot.hardwareId,
        start_date: this.newTroubleshoot.startDate,
        status: this.newTroubleshoot.status,
        complaint: this.newTroubleshoot.complaint,
        location_id: this.newTroubleshoot.locationId,
        notes: this.newTroubleshoot.notes,
        technician_name: localStorage.getItem("currentUser"),
        type_device: this.newTroubleshoot.typeDevice,
        responsible_person: this.newTroubleshoot.responsiblePerson,
        no_hp: this.newTroubleshoot.noHp,
        photo_id: photoId 
      }, { 
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') }
      })
      .then(() => {
        this.newSaved = true;
        this.removeImage(); 
        if (typeof this.getTroubleshoots === "function") this.getTroubleshoots();
        
        setTimeout(() => { 
          this.formTroubleshootActive = false; 
          this.savingNew = false; 
          this.newSaved = false; 
          this.newhardwareidlabel = '';
          this.selectedHardwareSetup = {};

          this.newTroubleshoot.typeDevice = '';
          this.newTroubleshoot.responsiblePerson = '';
          this.newTroubleshoot.noHp = '';
        }, 1000);
      })
      .catch((err) => {
        this.savingNew = false;
        this.errorNew = true;
        this.createErrorMessage = err.response.data.message || "Failed to save Troubleshoot data.";
      });
    },
  
    
    openEdit(obj, index) {
      const role = localStorage.getItem('role');
      // Protection: If status is Close, only admin/master_admin can edit
      if (obj.status === 'Close' && !['admin', 'master_admin'].includes(role)) {
        alert("Only Admin can change data with Close status.");
        return;
      }
      this.dataEdit = JSON.parse(JSON.stringify(obj));
      this.$bvModal.show('modal-edit-troubleshoot');
    },
    updateTroubleshootData(bvModalEvt) {
      bvModalEvt.preventDefault(); 

      if (this.selectedFile) {
        const photoData = new FormData();
        
        photoData.append('image', this.selectedFile); 

        console.log("=== MEMULAI UPLOAD KE SYNOLOGY ===");
        
        axios.post(this.$baseUrl + '/api/v1/photos/upload', photoData, {
          headers: { 
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken')
          }
        })
        .then((response) => {
          console.log("=== UPLOAD GAMBAR BERHASIL ===", response.data);

          
          if (response.data && response.data.data && response.data.data.id) {
            this.dataEdit.photo_id = response.data.data.id; 
            console.log("Photo ID berhasil disisipkan:", this.dataEdit.photo_id);
          } else {
            console.warn("Peringatan: Struktur response sukses berbeda, photo_id gagal dibaca.");
          }

         
          this.submitUpdateTroubleshoot();
        })
        .catch((error) => {
          console.error("=== API UPLOAD MENOLAK DATA (ERROR) ===");
          
          if (error.response) {
            console.error("Status Code Backend:", error.response.status);
            console.error("ALASAN EROR DARI BACKEND:", error.response.data);
            alert("Gagal upload! Pesan Server: " + JSON.stringify(error.response.data));
          } else {
            console.error("Error Jaringan:", error.message);
            alert("Gagal mengupload gambar karena masalah jaringan.");
          }
        });
      } else {
       
        this.submitUpdateTroubleshoot();
      }
    },

    submitUpdateTroubleshoot() {
      
      console.log("Payload data yang dikirim ke PUT API:", this.dataEdit);

      axios.put(this.$baseUrl + '/api/troubleshoot/' + this.dataEdit.id, this.dataEdit, {
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('accessToken') }
      })
      .then(() => {
        console.log("=== DATA TROUBLESHOOT BERHASIL DISIMPAN ===");
        this.$bvModal.hide('modal-edit-troubleshoot');
        
        if (typeof this.getTroubleshoots === 'function') {
          this.getTroubleshoots(); // Refresh tabel data utama
        }
        this.removeImage();
      })
      .catch((err) => {
        console.error("Gagal melakukan PUT data:", err);
        alert("Gagal memperbarui data troubleshoot ke database.");
      });
    },
    

    smartSearchAddIdTransmitter(data) { this.newTroubleshoot.hardwareId = data.id; this.selectedHardwareSetup = data; },
    smartSearchAddComplaint(data) { this.newTroubleshoot.complaint = data.complaint_name; },
    smartSearchAddLocation(data) { this.newTroubleshoot.locationId = data.id; },
    updateStatus(val) { this.newTroubleshoot.status = val; },
    deleteResult(res) { if (res) this.getTroubleshoots(); },
    
    checkRoleUpdate(obj) {
      const role = localStorage.getItem('role');
      if (obj.status === 'Close') return ['admin', 'master_admin'].includes(role);
      return true;
    },
    checkRoleDelete() { 
      return ['admin', 'master_admin'].includes(localStorage.getItem('role')); 
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active { transition: opacity 0.4s, transform 0.4s; }
.fade-enter, .fade-leave-to { opacity: 0; transform: translateY(-20px); }

/* Custom Styling untuk Mobile Card */
.mobile-card {
  border-left: 5px solid #dee2e6;
  background: #ffffff;
}
.border-left-success { border-left-color: #28a745 !important; }
.border-left-warning { border-left-color: #ffc107 !important; }
.border-left-secondary { border-left-color: #6c757d !important; }

.table th { background-color: #f1f3f5; color: #495057; font-size: 0.8rem; border: none; }
.btn-group .btn { border-color: #eee; }
.btn-group .btn:disabled { opacity: 0.5; cursor: not-allowed; }

::v-deep .modal-body { max-height: 450px; overflow-y: auto; }
</style>